import { render, staticRenderFns } from "./TinyMceInput.vue?vue&type=template&id=9851b220&lang=html"
import script from "./TinyMceInput.vue?vue&type=script&lang=js"
export * from "./TinyMceInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/alquant/white-label-platforms/platform-onyx-fo/platform/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9851b220')) {
      api.createRecord('9851b220', component.options)
    } else {
      api.reload('9851b220', component.options)
    }
    module.hot.accept("./TinyMceInput.vue?vue&type=template&id=9851b220&lang=html", function () {
      api.rerender('9851b220', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/input/TinyMceInput.vue"
export default component.exports